"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
const config_1 = require("../config");
class View {
    _parentElement = config_1.THE_BOARD;
}
exports.View = View;
